/**
 * SI EL CHECK-IN DIARIO DE HOY ESTÁ PENDIENTE, EN UN SOLO SITIO.
 *
 * Lo lee la puerta «Check-in diarios» de Seguimiento. `estado` es la respuesta de
 * `/checkins/estado`. Desde el 25-10 no hay ventana: el check-in es siempre el de hoy, a
 * cualquier hora, así que está pendiente mientras el de hoy no esté hecho.
 */
export function checkInPendiente(estado) {
    if (!estado) return false;
    return !estado.hecho && estado.quiere_cierre !== false;
}

/** El aviso de la puerta de Seguimiento. */
export const avisoDelCheckIn = (estado) => (checkInPendiente(estado)
    ? 'Check-in de hoy disponible'
    : null);

/**
 * LA FILA «CHECK-IN DIARIO» DE MI DÍA (artefacto de Enrique, 26-10): RELLENAR, CONTINUAR
 * con lo que ya tiene guardado («Tienes guardado el sueño y el peso») o hecho.
 *
 * `empezado` es que guardó a medias el paso del peso y el sueño (`PUT /checkins/borrador`);
 * el peso cuenta aparte porque se guarda por su cuenta, aunque no haya borrador.
 */
export function filaDelCheckIn(estado) {
    if (estado?.hecho) return { hecho: true, accion: null, detalle: null };
    const guardado = [estado?.sueno_guardado && 'el sueño', estado?.peso_de_hoy && 'el peso'].filter(Boolean);
    return {
        hecho: false,
        accion: estado?.empezado ? 'Continuar' : 'Rellenar',
        detalle: guardado.length ? `Tienes guardado ${guardado.join(' y ')}` : null,
    };
}
